import React from 'react';

const Reload: React.FC = () => {
  return (
    <svg
      className="h-4 w-4 inline-block mx-2"
      viewBox="0 0 25 25"
      fill="currentColor"
    >
      <path
        d="M16.3461 2.63729L18.9834 0V7.91187H11.0715L14.711 4.27241C13.3747 2.93618 11.7924 2.26807 9.96386 2.26807C8.10016 2.26807 6.50901 2.92739 5.19036 4.24604C3.87171 5.56469 3.21239 7.15584 3.21239 9.01953C3.21239 10.8832 3.87171 12.4744 5.19036 13.793C6.50901 15.1117 8.10016 15.771 9.96386 15.771C11.4407 15.771 12.7594 15.3578 13.9198 14.5315C15.0802 13.7051 15.889 12.6238 16.3461 11.2876H18.6669C18.1746 13.2568 17.1197 14.8743 15.5022 16.1402C13.8846 17.4061 12.0385 18.0391 9.96386 18.0391C7.50237 18.0391 5.39256 17.16 3.63436 15.4018C1.87616 13.6436 0.99707 11.5162 0.99707 9.01953C0.99707 6.52288 1.87616 4.39549 3.63436 2.63729C5.39256 0.879088 7.50237 0 9.96386 0C12.4605 0 14.5879 0.879088 16.3461 2.63729Z"
        className="checkout-panel-icon-color"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 10 10;360 10 10"
        />
      </path>
    </svg>
  );
};

export default Reload;
